import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { Observable, catchError, firstValueFrom, of } from 'rxjs';
import { DialogService } from '../../core/services/dialog-service';
import { RestApiService } from '../../core/services/rest-api-service';
import { NativeAppService } from '../../core/services/native-app.service';
import { Browser } from '@capacitor/browser';
import { environment } from '../../../environments/environment';

export const registerGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const dialogService = inject(DialogService);

  /*
  const nativeAppService = inject(NativeAppService);
  if (nativeAppService.isNativePlatform() && _route.url.find(u => u.path == 'register-for-provider')) {
    var url = environment.siteUrl + (_route.params['lang'] || 'en') + '/register-for-provider'
    Browser.open({ url });
    console.log('open browser at: ', url)
    return false;
  }*/
  const permissionPromise = firstValueFrom(
    inject(RestApiService)
      .getMe(true)
      .pipe(
        catchError(_err => {
          return of(null);
        })
      )
  ).then(me => {
    if (me) {
      dialogService.openAlertDialog(
        _('Már be vagy jelentkezve!'),
        _(
          'Egy e-mail címmel csak egy profil regisztrálható. Jelentkezz ki, és egy másik e-mail címmel indíts új regisztrációt.'
        )
      );
      return false;
    } else return true;
  });
  return permissionPromise;
};
